// region :: Imports ::
import MServiceBase from '../Toolkit/ServiceBase';
import {AddWorkerToNhsRequest, WorkerHubClientConfiguration, WorkerNhsClient} from '../Api/WorkerHubClients';
import MInvokeResult from '../Toolkit/InvokeResult';
import {IMsalContext} from '@azure/msal-react';

//endregion

/** */
class WorkerNhsService extends MServiceBase {

    private readonly m_client: WorkerNhsClient;

    /** */
    public constructor(msalContext: IMsalContext) {
        super();

        this.m_client = new WorkerNhsClient(
            new WorkerHubClientConfiguration(msalContext), process.env.REACT_APP_WORKERHUB_API);

    }

    /** */
    public async addWorker(workerId: string, request: AddWorkerToNhsRequest): Promise<MInvokeResult> {

        return await this.invoke(
            async() => await this.m_client.add(workerId, request));

    }

}

export default WorkerNhsService;
